var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgG6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 4,
    fill: "#FBE942"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.875 8.05876H20.7499V7H19.6875V8.05876H13.3125V7H12.2501V8.05876H10.125C9.56154 8.05876 9.02099 8.28193 8.62238 8.67899C8.22394 9.07622 8 9.61491 8 10.1765V22.8823C8 23.4439 8.22394 23.9825 8.62238 24.3798C9.02099 24.7768 9.56154 25 10.125 25H22.875C23.4385 25 23.979 24.7768 24.3776 24.3798C24.7761 23.9825 25 23.4439 25 22.8823V10.1765C25 9.61491 24.7761 9.07623 24.3776 8.67899C23.979 8.28193 23.4385 8.05876 22.875 8.05876ZM16.5 21.8237C15.0911 21.8237 13.7398 21.2659 12.7435 20.2731C11.7472 19.2802 11.1875 17.9336 11.1875 16.5296C11.1875 15.1255 11.7472 13.7789 12.7435 12.7861C13.7398 11.7932 15.0911 11.2354 16.5 11.2354C17.9089 11.2354 19.2602 11.7932 20.2565 12.7861C21.2528 13.7789 21.8125 15.1255 21.8125 16.5296C21.8125 17.9336 21.2528 19.2802 20.2565 20.2731C19.2602 21.2659 17.9089 21.8237 16.5 21.8237Z",
    fill: "#F9F9F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4719 19.0024L16.121 17.0447L19.4918 15.1217L19.4719 19.0024Z",
    fill: "#F9F9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 19.1123,
    width: 1,
    height: 4,
    transform: "rotate(-180 15 19.1123)",
    fill: "#F9F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG6);
export default __webpack_public_path__ + "static/media/g6.42b68748ec13a888d9d902a00a30a95e.svg";
export { ForwardRef as ReactComponent };